import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  location:
    typeof window !== 'undefined'
      ? JSON.parse(localStorage.getItem('location') || 'null')
      : null,
};

const userLocationSlice = createSlice({
  name: 'userLocation',
  initialState,
  reducers: {
    updateUserLocation(state, action) {
      state.location = action.payload;
      if (typeof window !== 'undefined') {
        localStorage.setItem('location', JSON.stringify(action.payload));
      }
    },
    hydrateUserLocation(state, action) {
      const location = action.payload;
      if (location) {
        state.location = location;
        if (typeof window !== 'undefined') {
          localStorage.setItem('location', JSON.stringify(location));
        }
      }
    },
  },
});

const { actions, reducer: UserLocationReducer } = userLocationSlice;

export const { updateUserLocation, hydrateUserLocation } = actions;
export default UserLocationReducer;
